var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "max-w-3xl mx-auto mt-5" }, [
    _c(
      "div",
      { staticClass: "bg-white shadow overflow-hidden sm:rounded-lg" },
      [
        _c(
          "div",
          { staticClass: "px-4 py-5 border-b border-gray-200 sm:px-6" },
          [
            _c(
              "h3",
              { staticClass: "text-lg leading-6 font-medium text-gray-900" },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.report.name) +
                    " - " +
                    _vm._s(_vm._f("dateFilter")(_vm.report.createdAt)) +
                    " "
                )
              ]
            )
          ]
        ),
        _c("div", { staticClass: "px-4 py-5 sm:p-0" }, [
          _c("dl", [
            _c(
              "div",
              {
                staticClass: "sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5"
              },
              [
                _c(
                  "dt",
                  {
                    staticClass: "text-sm leading-5 font-medium text-gray-500"
                  },
                  [_vm._v(" Total Carts ")]
                ),
                _c(
                  "dd",
                  {
                    staticClass:
                      "mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                  },
                  [_vm._v(" " + _vm._s(_vm.report.total) + " ")]
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
              },
              [
                _c(
                  "dt",
                  {
                    staticClass: "text-sm leading-5 font-medium text-gray-500"
                  },
                  [_vm._v(" Sent ")]
                ),
                _c(
                  "dd",
                  {
                    staticClass:
                      "mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                  },
                  [_vm._v(" " + _vm._s(_vm.report.success) + " ")]
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
              },
              [
                _c(
                  "dt",
                  {
                    staticClass: "text-sm leading-5 font-medium text-gray-500"
                  },
                  [_vm._v(" Failed/Not on whatsapp ")]
                ),
                _c(
                  "dd",
                  {
                    staticClass:
                      "mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                  },
                  [_vm._v(" " + _vm._s(_vm.report.failed) + " ")]
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
              },
              [
                _c(
                  "dt",
                  {
                    staticClass: "text-sm leading-5 font-medium text-gray-500"
                  },
                  [_vm._v(" Numbers sent ")]
                ),
                _c(
                  "dd",
                  {
                    staticClass:
                      "mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                  },
                  _vm._l(_vm.successfulCheckouts, function(checkout) {
                    return _c("span", { key: checkout.id }, [
                      _vm._v(" " + _vm._s(checkout.customer.phoneNumber) + " ")
                    ])
                  }),
                  0
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
              },
              [
                _c(
                  "dt",
                  {
                    staticClass: "text-sm leading-5 font-medium text-gray-500"
                  },
                  [_vm._v(" Numbers Failed ")]
                ),
                _c(
                  "dd",
                  {
                    staticClass:
                      "mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                  },
                  [
                    _vm._l(_vm.failedCheckouts, function(checkout) {
                      return _c("span", { key: checkout.id }, [
                        _vm._v(
                          " " + _vm._s(checkout.customer.phoneNumber) + " "
                        )
                      ])
                    }),
                    _vm.failedCheckouts.length === 0
                      ? _c("span", [_vm._v("No failed numbers")])
                      : _vm._e()
                  ],
                  2
                )
              ]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }